import { render, staticRenderFns } from "./ReglementForm.vue?vue&type=template&id=4e09c2a2"
import script from "./ReglementForm.vue?vue&type=script&lang=js"
export * from "./ReglementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports